export enum CompositeTypeEnum {
  BABY = "BABY",
  VOGUE_ADULTO = "VOGUE_ADULTO",
  VOGUE_INFANTIL = "VOGUE_INFANTIL",
  YOUNIQUE_ADULTO = "YOUNIQUE_ADULTO",
  YOUNIQUE_INFANTIL = "YOUNIQUE_INFANTIL",
}
